var DomainType = /* @__PURE__ */(DomainType2 => {
  DomainType2["BRN"] = "BRN";
  DomainType2["BAN"] = "BAN";
  return DomainType2;
})(DomainType || {});
export { DomainType };